import { motion } from 'framer-motion'
import { useSlideCopy } from '@/lib/i18n'
import type { SlideProps } from '@/components/SlideWizard'
import { copy } from './Slide3Secrecy.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide3Secrecy(_props: SlideProps) {
  const c = useSlideCopy(copy)

  return (
    <div className="flex flex-col items-start text-start px-4 max-w-2xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1, ease }}
        className="border-s-4 border-red-400 ps-6"
      >
        <h2 className="text-3xl sm:text-4xl font-semibold text-slate-900 tracking-tight leading-[1.15]">
          {c.heading}
        </h2>
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6, ease }}
        className="mt-8 text-xl sm:text-2xl text-slate-500 leading-relaxed"
      >
        {c.body1}
      </motion.p>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.9, ease }}
        className="mt-6 text-xl sm:text-2xl text-slate-500 leading-relaxed"
      >
        {c.body2}
      </motion.p>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.2, ease }}
        className="mt-6 text-xl sm:text-2xl text-slate-900 leading-relaxed font-medium"
      >
        {c.body3}
      </motion.p>
    </div>
  )
}
